import * as React from 'react';

import CSVDownload from 'components/CSVDownload';
import usePqTransform from 'hooks/usePqTransform';
import { KeyedReportDetailRow } from 'hooks/useReportSummary';

import { sortByPq } from '../utils';

interface ReportProps {
  reportName: string;
  reportSummaryData: KeyedReportDetailRow[];
}

const ReportSummaryCsv: React.FC<ReportProps> = (props) => {
  const { reportName, reportSummaryData } = props;
  const pq = usePqTransform();

  const getCsvHeader = () => [
    { label: 'Product', key: 'product' },
    { label: pq.label, key: 'pq' },
    { label: 'Win Rate', key: 'winRate' },
    { label: 'Polarization', key: 'polarization' },
  ];

  const getCsvData = (data: KeyedReportDetailRow[]) =>
    data
      .sort((a, b) => sortByPq(a, b))
      .map((row) => ({
        product: row.productByProductId.name,
        pq: pq.format(row.pq),
        winRate: `${parseFloat(row.pComp).toFixed(0)}%`,
        polarization: parseFloat(row.polarization).toFixed(2),
      }));

  return (
    <CSVDownload
      headers={getCsvHeader()}
      csvData={getCsvData(reportSummaryData)}
      fileName={`${reportName}-StackRank.csv`}
    />
  );
};

export default ReportSummaryCsv;
